<template>
    <div class="error-bar">
        <transition name="slide">
            <div
                v-if="errorMessage"
                class="content"
            >
                <div class="wrapper">
                    <div class="message">
                        {{ errorMessage }}
                    </div>

                    <div
                        class="clear-button"
                        @click="clear"
                    >
                        Dismiss
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useErrorBarStore } from './useErrorBar'

const store = useErrorBarStore()

const { clear } = store
const { errorMessage } = storeToRefs(store)
</script>

<style lang="scss" scoped>
.error-bar {
    width: 100%;
    height: 0;

    .content {
        padding: 0 16px;
        background-color: $red;
        color: $white;

        display: flex;
        justify-content: center;

        @include min-width(1024) {
            padding: 0 20px;
        }

        @include min-width(1280) {
            padding: 0 40px;
        }

        .wrapper {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            max-width: 1360px;

            .clear-button {
                padding: 4px 8px;
                border-radius: 16px;
                border: 1px $white solid;

                cursor: pointer;

                font-family: $effra-font-stack;
                font-weight: 500;
                font-size: 0.875rem;
                line-height: 1.313rem;
                letter-spacing: 0.05em;
                text-transform: uppercase;
            }
        }
    }
}

.slide-enter-active,
.slide-leave-active,
.slide-reverse-enter-active,
.slide-reverse-leave-active {
    transition: all 175ms var(--timing-function-easing-accelerate);
}

.slide-enter-from,
.slide-reverse-leave-to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
}

.slide-leave-to,
.slide-reverse-enter-from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
}
</style>
